/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Appinfo_DescriptionInputs */

const en_admin_settings_groups_appinfo_description = /** @type {(inputs: Admin_Settings_Groups_Appinfo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic application settings`)
};

/**
* | output |
* | --- |
* | "Basic application settings" |
*
* @param {Admin_Settings_Groups_Appinfo_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_appinfo_description = /** @type {((inputs?: Admin_Settings_Groups_Appinfo_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Appinfo_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_appinfo_description(inputs)
});
export { admin_settings_groups_appinfo_description as "admin.settings.groups.appinfo.description" }